import { TherapyRelationshipType } from "~/prisma/browser";

/**
 * Resolves the legacy couples-directory flag to the explicit booking type.
 * An explicit therapyType always wins so links can deliberately override it.
 */
export function resolveTherapyTypeQuery({
  therapyType,
  couples,
}: {
  therapyType: string | null | undefined;
  couples: string | null | undefined;
}): TherapyRelationshipType {
  if (therapyType === TherapyRelationshipType.INDIVIDUAL) {
    return TherapyRelationshipType.INDIVIDUAL;
  }

  if (therapyType === TherapyRelationshipType.COUPLES || couples === "1") {
    return TherapyRelationshipType.COUPLES;
  }

  return TherapyRelationshipType.INDIVIDUAL;
}
